import { render, staticRenderFns } from "./KaowuFuwu.vue?vue&type=template&id=23e109f4&scoped=true&"
import script from "./KaowuFuwu.vue?vue&type=script&lang=js&"
export * from "./KaowuFuwu.vue?vue&type=script&lang=js&"
import style0 from "./KaowuFuwu.vue?vue&type=style&index=0&id=23e109f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e109f4",
  null
  
)

export default component.exports